export default __webpack_public_path__ + "static/media/placeholder_profile_pic.33800973.jpg";